(function (app, ng) {
    app.controller("OpenRequirementController", OpenRequirementController);

    OpenRequirementController.$inject = ['$mdDialog'];
    function OpenRequirementController($mdDialog) {
        var $ctrl = this;
        ng.extend($ctrl,
            {
            });

        $ctrl.closeDialog = function(event) {
            $mdDialog.hide(event);
        }
    }
})(window.app, window.angular); // jshint ignore:line